import React from "react";
import "./cta.css";
import arrowImage from "../../images/green-arrow.svg";
import ScrollReveal from "../scrollReveal/scrollReveal";
import config from "../../config";

const CTASection = () => {
  const handleBookDemoClick = () => {
    window.location.href = config.bookdemo.Link;
  };

  return (
    <ScrollReveal>
      <section className="cta-section cta-container">
        <div className="cta-content">
          <h1>
            Unlock the Potential of Reliable and Transparent AI Operations.{" "}
          </h1>
          <p>
            Discover how quality assurance and risk management can elevate your
            AI solutions
          </p>
          <div className="cta-book-demo-button" onClick={handleBookDemoClick}>
            <span>Book Demo</span>
            <img src={arrowImage} alt="arrow Icon" />
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
};

export default CTASection;
